exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.TicketFormOperationBar {\r\n  min-height: 45px;\r\n  width: 60vw;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  z-index: 9999;\r\n  position: fixed;\r\n  bottom: 0;\r\n  -webkit-box-shadow: 0 -1px 3px rgba(0,0,0,.15);\r\n          box-shadow: 0 -1px 3px rgba(0,0,0,.15);\r\n  background: #efefefcc;\r\n  padding:0 10px 0 10px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ff6c65f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketFormOperationBar.vue
// module id = 835
// module chunks = 75